<div class="ap-grid ap-grid-cols-2 ap-grid-cols-sm-1">
    <div>
        <ap-input-skeleton></ap-input-skeleton>
    </div>
    <div>
        <ap-input-skeleton></ap-input-skeleton>
    </div>
</div>
<ap-button-skeleton class="ap-sign__digicode-skeleton_button"></ap-button-skeleton>
